import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação (tutor ou usuário)
api.interceptors.request.use(
  (config) => {
    // Prioriza token de tutor, depois token de usuário
    const tutorToken = localStorage.getItem('tutor_token');
    const userToken = localStorage.getItem('token');
    const token = tutorToken || userToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação e CORS
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log detalhado do erro para debug
    if (error.response) {
      // Erro com resposta do servidor
      console.error('❌ Erro na resposta:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        headers: error.response.headers,
        url: error.config?.url,
        method: error.config?.method,
        origin: window.location.origin,
      });
    } else if (error.request) {
      // Requisição foi feita mas não houve resposta (CORS, timeout, etc)
      console.error('❌ Erro na requisição (sem resposta):', {
        url: error.config?.url,
        method: error.config?.method,
        baseURL: error.config?.baseURL,
        origin: window.location.origin,
        message: error.message,
        code: error.code,
        request: error.request,
      });
      
      // Se for erro de CORS, adiciona mensagem mais clara
      if (error.message?.includes('CORS') || error.code === 'ERR_FAILED') {
        const corsError = {
          ...error,
          corsError: true,
          message: `Erro de CORS: A requisição para ${error.config?.baseURL}${error.config?.url} foi bloqueada. Verifique se o backend está configurado para aceitar requisições de ${window.location.origin}`,
          details: {
            origin: window.location.origin,
            target: `${error.config?.baseURL}${error.config?.url}`,
            method: error.config?.method,
          },
        };
        return Promise.reject(corsError);
      }
    } else {
      // Erro ao configurar a requisição
      console.error('❌ Erro ao configurar requisição:', error.message);
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('tutor_token');
      localStorage.removeItem('user');
      localStorage.removeItem('tutor');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

